import { useMediaQuery } from 'react-responsive'
import {
  RESPONSIVE_BREAKPOINT_VERSIONS,
  useResponsiveBreakpointsVersion
} from 'contexts/ResponsiveBreakpointsContext'
import { selectResponsiveBreakpointQuery } from 'styles/breakpoints'

const useBreakpoint = (queryName, { legacyQuery } = {}) => {
  const version = useResponsiveBreakpointsVersion()

  return useMediaQuery({
    query: selectResponsiveBreakpointQuery(queryName, {
      legacyQuery,
      useCanonical: version === RESPONSIVE_BREAKPOINT_VERSIONS.V2
    })
  })
}

export default useBreakpoint
